import { PdfAccessTag } from "components/PdfAccessTag";
import { LibraryIcon } from "features/libraries";
import { Paper, PaperDetails } from "helpers/api";
import useLabels from "hooks/useLabels";
import { usePdfAccessHierarchy } from "hooks/usePdfAccessHierarchy";
import { OpenAccessIcon } from "design_system";

type PdfAccessIndicatorProps = {
  paper: Paper | PaperDetails;
};

/**
 * @component PdfAccessIndicator
 * @description Shows the appropriate PDF access icon in the bottom right corner of search results
 */
export const PdfAccessIndicator = ({ paper }: PdfAccessIndicatorProps) => {
  const [labels] = useLabels("screens.details");
  const { option, label, icon: pdfIcon } = usePdfAccessHierarchy(paper);

  // Don't show anything if no access option is available
  if (!option) {
    return null;
  }

  const getIcon = () => {
    switch (option) {
      case "uploaded":
        return pdfIcon as string;
      case "library":
        return (
          <LibraryIcon
            size={16}
            includeTooltip={false}
            includePadding={false}
          />
        );
      case "open-access":
        return <OpenAccessIcon size="sm" />;
      case "doi":
        return null;
      default:
        return null;
    }
  };

  const icon = getIcon();
  if (!icon) {
    return null;
  }

  const displayText = label === labels["full-text"] ? labels["pdf"] : label;

  return <PdfAccessTag icon={icon} text={displayText} alt={displayText} />;
};
